import Typesense from 'typesense'
import { getSecret } from '@/composables/useSecrets'

let _client
let _apiKey = null

export function initTypesenseKey() {
  _apiKey = getSecret('typesense_api_key')
}

function initClient() {
  let nodes

  if (import.meta.env.VITE_TYPESENSE_NODES) {
    const hosts = import.meta.env.VITE_TYPESENSE_NODES
      .split(',')
      .map(host => host.trim())
      .filter(Boolean)

    nodes = hosts.map(host => {
      return {
        host,
        port: 443,
        protocol: 'https'
      }
    })
  }

  return new Typesense.Client({
    apiKey: _apiKey,
    numRetries: 3,
    connectionTimeoutSeconds: 10,
    retryIntervalSeconds: 0.1,
    healthcheckIntervalSeconds: 2,
    nearestNode: {
      host: import.meta.env.VITE_TYPESENSE_HOST,
      port: 443,
      protocol: 'https'
    },
    nodes
  })
}

function client({ unique } = {}) {
  if (unique) {
    return initClient()
  }
  if (!_client) {
    _client = initClient()
  }
  return _client
}

export function getTypesenseApiKey() {
  return _apiKey
}

export function useTypesense() {
  return {
    client
  }
}
